







import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { BIcon } from "bootstrap-vue";

@Component({ components: { BIcon } })
export default class PasswordRule extends Vue {
  @Prop() hasError?: boolean;
  @Prop() message!: string;

  get className() {
    if (this.hasError === true) return "invalid";
    if (this.hasError === false) return "valid";

    // undefined, meaning no validation has been performed
    return "";
  }

  get icon() {
    if (this.hasError === true) return "x";
    if (this.hasError === false) return "check";

    // undefined, meaning no validation has been performed
    return "dot";
  }

  get scale() {
    return this.hasError === undefined ? 1.5 : 1.3;
  }
}
